import * as React from "react";

const TestEnvironmentDropdown: React.FC = () => {
  const popoverRef = React.useRef<HTMLDivElement>(null);
  const [apiEnvironment, setApiEnvironment] = React.useState<string>("");

  React.useEffect(() => {
    const stored = localStorage.getItem("API_ENVIRONMENT");
    if (stored) {
      setApiEnvironment(stored);
    }
  }, []);

  // NOTE: Hide button if API url is not used and if origin does not end with ".wint.se"
  if ((import.meta.env.VITE_SUPERKOLL_SERVER_URL ?? "/") === "/" || !window.location.origin.endsWith(".wint.se")) {
    return null;
  }

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setApiEnvironment(value);
    localStorage.setItem("API_ENVIRONMENT", value);
    window.location.reload();
  };

  const startDragging = (e: React.PointerEvent) => {
    const el = popoverRef.current;
    if (!el) return;

    const target = e.currentTarget as HTMLElement;
    target.setPointerCapture(e.pointerId);

    const rect = el.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;

    const onPointerMove = (moveEvent: PointerEvent) => {
      const newX = moveEvent.clientX - offsetX;
      const newY = moveEvent.clientY - offsetY;

      el.style.left = `${newX}px`;
      el.style.top = `${newY}px`;
      el.style.margin = "0";
    };

    const onPointerUp = () => {
      target.releasePointerCapture(e.pointerId);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onPointerUp);
    };

    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);
  };

  return (
    <>
      <button
        // @ts-expect-error - popovertarget is modern HTML (lowercase suppresses React warning)
        popovertarget="test-menu"
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1700,
          cursor: "pointer",
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "12px",
          padding: "8px 16px",
          fontSize: "14px",
          fontWeight: 500,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#333",
          pointerEvents: "auto",
        }}
      >
        <span style={{ fontSize: "16px" }}>🔧</span> Test Tools
      </button>

      <div
        id="test-menu"
        ref={popoverRef}
        // @ts-expect-error - popover is modern HTML
        popover="auto"
        style={{
          inset: "unset",
          // Positions the popover 10px above the button (button is 20px from bottom)
          bottom: "70px",
          right: "20px",
          // We set top/left to auto so bottom/right take precedence initially
          top: "auto",
          left: "auto",
          border: "1px solid #ccc",
          padding: 0,
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          borderRadius: "12px",
          background: "white",
          overflow: "hidden",
          width: "260px",
          zIndex: 1700,
          position: "fixed",
        }}
      >
        <div
          onPointerDown={startDragging}
          style={{
            padding: "10px 12px",
            background: "#f8f9fa",
            cursor: "grab",
            userSelect: "none",
            borderBottom: "1px solid #eee",
            fontSize: "11px",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "#666",
          }}
        >
          ⋮⋮ Drag to move
        </div>

        <div style={{ padding: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontSize: "13px", fontWeight: 600, color: "#444" }}>
            API Environment
          </label>
          <select
            value={apiEnvironment}
            onChange={handleSelectChange}
            style={{ width: "100%", padding: "6px", borderRadius: "6px", border: "1px solid #ddd" }}
          >
            <option value="https://apitest.wint.se">Test - apitest.wint.se</option>
            <option value="https://apistaging.wint.se">Staging - apistaging.wint.se</option>
            <option value="https://api.wint.se">Production - api.wint.se</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default TestEnvironmentDropdown;
